var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"date-empty-placeholder"},[_c('p',{staticClass:"text-gray text-center"},[_vm._v(_vm._s(_vm.$translate('my-calendar_date-empty')))])])}
var staticRenderFns = []

export { render, staticRenderFns }